angular.module("avant.customer_applications.directives").directive "customValidation", ->
  restrict: "A"
  require: 'ngModel'
  link: ($scope, element, attributes, ngModel) ->

    is_not_null = (value) ->
      return false if typeof value is 'undefined'
      return false if value == null or value == 'null'
      return false if typeof value is 'string' and value.trim() is ''
      true

    run_validation = (model, value) ->
      switch model.validation
        when undefined
          # default validation..check if field is not empty
          !!value
        when "regex"
          # DEPRECATED (but still used in legacy code)
          # Use the `regex_simplified` case below for all future partners.
          # FSTK-811 is a follow-up task to update all partners and remove this.
          re = new RegExp("#{model.parameter}")
          !!(value && re.test(value))
        when "regex_simplified"
          re = new RegExp(model.parameter)
          !!(value && re.test(value))
        when "regex_and_within_range"
          return false unless value
          re = new RegExp("#{model.parameter.characters}")
          # The value must be checked against the regex before it is cast to a
          # float. Otherwise the value that gets validated will not be the same
          # as the value that appears on the form and will be sent to the server.
          return false unless re.test(value)
          # Remove everything except digits and periods; '$' is allowed at the
          # beginning, but will cause the string to parse as NaN
          value = parseFloat(value.replace(/[^\d\.]/g, "")) if typeof value == "string"
          !!(value && value >= model.parameter.min && value <= model.parameter.max)
        when "email"
          re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          guest = /@example\.com$/
          !!(value && re.test(value) && !guest.test(value))
        when "checkbox"
          # Assumption that checkbox values will stored in array
          # Used in fields/optional_customer_info/_race.html.haml
          return false unless ngModel.$modelValue
          ngModel.$modelValue.length > 0
        when "min_length"
          !!(value && value.length >= model.parameter)
        when 'length_range'
          !!(value && value.length >= model.parameter.min && value.length <= model.parameter.max)
        when 'complex_password'
          # This validation supports:
          # min_length, max_length, number_required, upper_required, lower_required (booleans)
          return false unless value
          params = model.parameters
          # Length
          if params.min_length
            return false unless value.length >= params.min_length
          if params.max_length
            return false unless value.length <= params.max_length
          # Alphabetic characters
          if params.alphabetic_required
            re = /[A-Za-z]/
            return false unless re.test(value)
          if params.upper_required
            re = /[A-Z]/
            return false unless re.test(value)
          if params.lower_required
            re = /[a-z]/
            return false unless re.test(value)
          # Numeric characters
          if params.number_required
            re = /[0-9]/
            return false unless re.test(value)
          if params.cannot_match_email
            email = $scope.$eval('customer.email')
            return true unless email && RegExp(email).test('@')
            emailArr = email.split('@')
            userName = emailArr[0]
            return false if (value.toUpperCase().match userName.toUpperCase())
          if params.spaces_not_allowed
            re = /^\S*$/
            return false unless re.test(value)
          if params.three_consecutive_characters_not_allowed
            re = /(.)\1{2}/
            return false if re.test(value)
          if params.allowed_characters
            re = new RegExp(params.allowed_characters)
            return false unless re.test(value)
          true
        when "matches_field"
          !!(!$scope.$eval(model.parameter) || $scope.$eval(model.parameter) is value)
        when "date"
          return false unless value
          dateString = value.split('/')
          parsedDate = Date.parse(dateString[0] + '/1/' + dateString[1])
          !isNaN(parsedDate)
        when "either_or"
          other_val = $scope.$eval(model.parameter)
          !!(value is true || value && value.length > 0) || !!(other_val is true || other_val && other_val.length > 0)
        when "if_less_than_6_months_at_address"
          return true if !$scope.$eval('customer.needs_previous_address')
          return true if $scope.$eval('customer_address.time_at_address') isnt '6_months_or_less'
          return !!(value is true || value && value.length > 0)
        when "not_null"
          is_not_null(value)
        else
          true

    run_bank_account_validation = (model, value) ->
      if $scope.$eval("product.payment_method") == 'ach' || $scope.$eval("product_funding_method.funding_method") == 'ach'
        run_validation(model, value)
      else
        true


    is_valid = (model, value) ->
      return true unless model
      switch model.required
        when true
          switch model.required_for_source
            when "non_post_lead"
              if $scope.$eval("lead.post_lead")
                true
              else
                run_validation(model, value)
            else
              run_validation(model, value)
        when "routing_number"
          $scope.$watch "bank_account.routing_number", ->
            ngModel.$setValidity "custom", run_validation(model, value)
          run_validation(model, value)
        when "if_income_type_visible"
          $scope.$watch "income_type_visible", ->
            if $scope["income_type_visible"]
              ngModel.$setValidity "custom", run_validation(model, value)
            else
              ngModel.$setValidity "custom", true
          if $scope["income_type_visible"]
            run_validation(model, value)
          else
            true
        when "if_retype_ssn_required"
          $scope.$watch "retype_field_section", ->
            if $scope["retype_field_section"]?["retype_ssn_required"]
              ngModel.$setValidity "custom", run_validation(model, value)
            else
              ngModel.$setValidity "custom", true
          if $scope["retype_field_section"]?["retype_ssn_required"]
            run_validation(model, value)
          else
            true
        when "if_customer_certain_state"
          $scope.$watch "customer_address.state", ->
            if $scope.$eval("customer_address.state") is model.state
              $scope["#{model.state}_checkbox_visible"] = true
              ngModel.$setValidity "custom", run_validation(model, value)
            else
              $scope["#{model.state}_checkbox_visible"] = false
              ngModel.$setValidity "custom", true
          if $scope.$eval("customer_address.state") is model.state
            $scope["#{model.state}_checkbox_visible"] = true
            run_validation(model, value)
          else
            $scope["#{model.state}_checkbox_visible"] = false
            true
        when "if_military_address"
          $scope.$watch "customer_address.military_address", ->
            if $scope.$eval("customer_address.military_address")
              ngModel.$setValidity "custom", run_validation(model, value)
            else
              ngModel.$setValidity "custom", true
          if $scope.$eval("customer_address.military_address")
            run_validation(model, value)
          else
            true
        when "if_previous_address_required"
          $scope.$watch "customer_address.time_at_address", ->
            ngModel.$setValidity "custom", run_validation(model, value)
          run_validation(model, value)
        when "if_paid_on_specific_day"
          $scope.$watch "income.pay_frequency", (pay_frequency) ->
            ngModel.$setValidity "custom", if pay_frequency == 'specific_day' then run_validation(model, value) else true
          run_validation(model, value)
        when "if_home_improvement"
          $scope.$watch "customer_application.loan_purpose", (loan_purpose) ->
            ngModel.$setValidity "custom", if loan_purpose == 'Home Improvement' then run_validation(model, value) else true
          run_validation(model, value)
        when "if_other_address_being_improved"
          $scope.$watch "optional_customer_info.address_being_improved", (address) ->
            ngModel.$setValidity "custom", if ($scope.customer_application.loan_purpose == 'Home Improvement' && address == 'Other') then run_validation(model, value) else true
          run_validation(model, value)
        when "if_home_improvement_address_different"
          $scope.$watch "customer_application_metadata.home_improvement_address_same_as_application", (address) ->
            ngModel.$setValidity "custom", if ($scope.customer_application.loan_purpose == 'Home Improvement' && address == 'no') then run_validation(model, value) else true
          run_validation(model, value)
        when "if_identification_type_us_military_id"
          $scope.$watch "identification.identification_type", (identification_type) ->
            ngModel.$setValidity "custom", if identification_type == 'us_military_id' then run_validation(model, value) else true
          run_validation(model, value)
        when "if_missing_time_at_address"
          $scope.$watch "customer_application_metadata.address_start_date", () ->
            validity = $scope.customer_address.time_at_address? or run_validation(model, value)
            ngModel.$setValidity "custom", validity
          run_validation(model, value)
        when "if_missing_time_at_job"
          $scope.$watch "customer_application_metadata.income_start_date", () ->
            ngModel.$setValidity "custom", if $scope.income.time_at_job then true else run_validation(model, value)
          run_validation(model, value)
        when "if_requires_identification_state"
          $scope.$watch "identification.identification_type", (identification_type) ->
            ngModel.$setValidity "custom", if (identification_type == 'drivers_license' || identification_type == 'state_issued_id') then run_validation(model, value) else true
          run_validation(model, value)
        when "if_customer_consent_required"
          run_validation(model, value)
        when "if_auto_lender_details_required"
          $scope.$watch "vehicle.auto_lender", (lender) ->
            ngModel.$setValidity "custom", if lender == 'none' || !$scope.hasAutoLenders() then run_validation(model, value) else true
          run_validation(model, value)
        when "if_auto_refinance_application_with_auto_lenders"
          $scope.$watch "vehicle.auto_lender", (lender) ->
            ngModel.$setValidity "custom", if $scope.hasAutoLenders() then run_validation(model, value) else true
          run_validation(model, value)
        when "if_rent_is_selected"
          $scope.$watch "customer_address.rent_or_own", (rent_or_own) ->
            if rent_or_own == 'rent'
              ngModel.$setValidity "custom", run_validation(model, value)
            else
              $scope.customer_address.monthly_housing_payment = null
              ngModel.$setValidity "custom", true
        when "if_bank_account_required"
          $scope.$watch "product_funding_method.funding_method", ->
            ngModel.$setValidity "custom", run_bank_account_validation(model, value)
          $scope.$watch "product.payment_method", ->
            ngModel.$setValidity "custom", run_bank_account_validation(model, value)
          run_bank_account_validation(model, value)
        when 'if_refinance_purpose_is_additional_funds'
          $scope.$watch "customer_application_metadata.refinance_purpose", (refi_purpose) ->
            ngModel.$setValidity "custom", if refi_purpose == 'additional_funds' then run_validation(model, value) else true
        when 'boolean_gate'
          $scope.$watch "boolean_gates.#{model.boolean_gate}", (gate_value) ->
            validity = if gate_value then run_validation(model, value) else true
            ngModel.$setValidity "custom", validity
          if $scope.boolean_gates[model.boolean_gate] then run_validation(model, value) else true
        else
          if model.validation == 'matches_field'
            $scope.$watch model.parameter, ->
              ngModel.$setValidity "custom", run_validation(model, value)
            run_validation(model, value)
          else if model.validation == 'regex' && !!value
            run_validation(model, value)
          else
            true

    model = if attributes.customValidation.length is 0 then attributes.ngModel else attributes.customValidation
    requirements = $scope.requirements[model]

    if requirements?.disabled
      switch requirements.disabled
        when "if_preapproved"
          $scope.$watch "disablePreapproved", (disabled) ->
            attributes.$set 'disabled', disabled || null
        when "is_post_lead"
          $scope.$watch "disablePostLead", (disabled) ->
            attributes.$set 'disabled', (disabled && is_not_null(ngModel.$modelValue)) || null
        when true
          attributes.$set 'disabled', true


    # For DOM -> model validation
    ngModel.$parsers.unshift (value) ->
      valid = is_valid($scope.requirements[model], value)
      ngModel.$setValidity "custom", valid
      if valid then element.removeClass('form__alert') else element.addClass('form__alert')
      value # (if valid then value else undefined)

    # For model -> DOM validation
    ngModel.$formatters.unshift (value) ->
      ngModel.$setValidity "custom", is_valid($scope.requirements[model], value)
      value
